import { useState, useEffect } from 'react'
import { adminApi } from '../services/api'
import { 
  Euro, 
  Users, 
  UserCheck,
  Clock,
  Check,
  X,
  Pencil,
  Eye,
  Sparkles,
  Building2,
  FileText,
  Info,
  AlertCircle,
  RefreshCw
} from 'lucide-react'

// Componente Card Preview
// FIX: Accetta betaMode come prop per controllo blur dinamico
const PlanCardPreview = ({ plan, isPreview = false, betaMode = true }) => {
  const formatPrice = (cents) => {
    if (!cents || cents === 0) return 'Gratis'
    return `€${(cents / 100).toFixed(2)}`
  }

  const formatLimit = (value) => {
    if (value === 999999 || value === -1) return 'Illimitati'
    return value
  }

  return (
    <div className={`bg-white rounded-xl shadow-lg border-2 ${plan.recommended ? 'border-primary-500' : 'border-gray-200'} p-6 relative ${isPreview ? 'scale-90' : ''}`}>
      {plan.recommended && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <span className="bg-primary-500 text-white text-xs font-bold px-3 py-1 rounded-full">
            CONSIGLIATO
          </span>
        </div>
      )}
      
      <div className="text-center mb-6">
        <h3 className="text-xl font-bold text-gray-900">{plan.displayName}</h3>
        <p className="text-gray-500 text-sm mt-1">{plan.description}</p>
      </div>

      {/* Prezzo - FIX: blur condizionale basato su betaMode */}
      <div className="text-center mb-6">
        <div className={betaMode ? "blur-lg select-none pointer-events-none" : ""}>
          <span className="text-4xl font-bold text-gray-900">
            {formatPrice(plan.pricing?.monthly?.onlus)}
          </span>
          <span className="text-gray-500">/mese</span>
        </div>
        {/* Badge Beta Tester - FIX: solo se betaMode è attivo */}
        {betaMode && (
          <div className="mt-2 inline-flex items-center gap-1 bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">
            <Sparkles className="w-4 h-4" />
            🎉 Sei un Beta Tester! Accesso gratuito
          </div>
        )}
      </div>

      <div className="space-y-3 mb-6">
        <div className="flex items-center gap-2">
          <Users className="w-5 h-5 text-primary-500" />
          <span className="text-gray-700">
            {formatLimit(plan.limits?.maxMinori)} minori
          </span>
        </div>
        <div className="flex items-center gap-2">
          <UserCheck className="w-5 h-5 text-primary-500" />
          <span className="text-gray-700">
            {formatLimit(plan.limits?.maxEducatori)} educatori
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Building2 className="w-5 h-5 text-primary-500" />
          <span className="text-gray-700">
            {formatLimit(plan.limits?.maxCoordinatori)} coordinatori
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-primary-500" />
          <span className="text-gray-700">
            {plan.limits?.storageMonths === 999999 ? 'Storico illimitato' : `${plan.limits?.storageMonths} mesi storico`}
          </span>
        </div>
      </div>

      <div className="border-t pt-4">
        <p className="text-xs text-gray-500 font-medium mb-2">Funzionalità incluse:</p>
        <div className="space-y-1">
          {plan.features?.export?.json && (
            <div className="flex items-center gap-1 text-xs text-gray-600">
              <Check className="w-3 h-3 text-green-500" /> Export JSON
            </div>
          )}
          {plan.features?.export?.csv && (
            <div className="flex items-center gap-1 text-xs text-gray-600">
              <Check className="w-3 h-3 text-green-500" /> Export CSV
            </div>
          )}
          {plan.features?.export?.excel && (
            <div className="flex items-center gap-1 text-xs text-gray-600">
              <Check className="w-3 h-3 text-green-500" /> Export Excel
            </div>
          )}
          {plan.features?.backup?.gdrive && (
            <div className="flex items-center gap-1 text-xs text-gray-600">
              <Check className="w-3 h-3 text-green-500" /> Backup Google Drive
            </div>
          )}
          {plan.features?.reports?.advanced && (
            <div className="flex items-center gap-1 text-xs text-gray-600">
              <Check className="w-3 h-3 text-green-500" /> Report avanzati
            </div>
          )}
        </div>
      </div>

      {/* Personalizzazione Form */}
      <div className="border-t pt-4 mt-4">
        <p className="text-xs text-gray-500 font-medium mb-2 flex items-center gap-1">
          <FileText className="w-3 h-3" />
          Personalizzazione Form:
        </p>
        <div className="space-y-1">
          {plan.planId === 'trial' || plan.planId === 'starter' ? (
            <>
              <div className="flex items-center gap-1 text-xs text-gray-400">
                <X className="w-3 h-3" /> Personalizza opzioni campi
              </div>
              <div className="flex items-center gap-1 text-xs text-gray-400">
                <X className="w-3 h-3" /> Sezioni personalizzate
              </div>
            </>
          ) : plan.planId === 'professional' ? (
            <>
              <div className="flex items-center gap-1 text-xs text-gray-600">
                <Check className="w-3 h-3 text-green-500" /> Personalizza opzioni (max 5)
              </div>
              <div className="flex items-center gap-1 text-xs text-gray-600">
                <Check className="w-3 h-3 text-green-500" /> Disabilita campi illimitati
              </div>
              <div className="flex items-center gap-1 text-xs text-gray-400">
                <X className="w-3 h-3" /> Sezioni personalizzate
              </div>
            </>
          ) : plan.planId === 'enterprise' ? (
            <>
              <div className="flex items-center gap-1 text-xs text-gray-600">
                <Check className="w-3 h-3 text-green-500" /> Personalizza opzioni (max 5)
              </div>
              <div className="flex items-center gap-1 text-xs text-gray-600">
                <Check className="w-3 h-3 text-green-500" /> Disabilita campi illimitati
              </div>
              <div className="flex items-center gap-1 text-xs text-gray-600">
                <Check className="w-3 h-3 text-green-500" /> 3 sezioni custom (max 5 elem.)
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  )
}

// Modal Modifica Piano
// FIX: Aggiunto betaMode per anteprima
const EditPlanModal = ({ plan, onClose, onSave, betaMode }) => {
  const [formData, setFormData] = useState({
    displayName: plan.displayName || '',
    description: plan.description || '',
    pricing: {
      monthly: {
        onlus: plan.pricing?.monthly?.onlus || 0,
        privato: plan.pricing?.monthly?.privato || 0
      },
      yearly: {
        onlus: plan.pricing?.yearly?.onlus || 0,
        privato: plan.pricing?.yearly?.privato || 0
      }
    },
    limits: {
      maxMinori: plan.limits?.maxMinori || 10,
      maxEducatori: plan.limits?.maxEducatori || 3,
      maxCoordinatori: plan.limits?.maxCoordinatori || 1,
      storageMonths: plan.limits?.storageMonths || 12
    },
    features: plan.features || {},
    recommended: plan.recommended || false,
    isActive: plan.isActive !== false
  })
  const [saving, setSaving] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaving(true)
    try {
      await onSave(plan.planId, formData)
      onClose()
    } catch (error) {
      console.error('Errore salvataggio:', error)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
          <h2 className="text-xl font-bold text-gray-900">
            Modifica Piano: {plan.displayName}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Colonna Form */}
            <div className="space-y-6">
              {/* Info Base */}
              <div>
                <h3 className="font-semibold text-gray-900 mb-3">Informazioni Base</h3>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Nome visualizzato
                    </label>
                    <input
                      type="text"
                      value={formData.displayName}
                      onChange={(e) => setFormData({ ...formData, displayName: e.target.value })}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Descrizione
                    </label>
                    <textarea
                      value={formData.description}
                      onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                      rows={2}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                  <div className="flex items-center gap-4">
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={formData.recommended}
                        onChange={(e) => setFormData({ ...formData, recommended: e.target.checked })}
                        className="rounded text-primary-500 focus:ring-primary-500"
                      />
                      <span className="text-sm text-gray-700">Consigliato</span>
                    </label>
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={formData.isActive}
                        onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                        className="rounded text-primary-500 focus:ring-primary-500"
                      />
                      <span className="text-sm text-gray-700">Attivo</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* Prezzi */}
              <div>
                <h3 className="font-semibold text-gray-900 mb-3">Prezzi (in centesimi)</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Mensile ONLUS
                    </label>
                    <input
                      type="number"
                      value={formData.pricing.monthly.onlus}
                      onChange={(e) => setFormData({
                        ...formData,
                        pricing: {
                          ...formData.pricing,
                          monthly: { ...formData.pricing.monthly, onlus: parseInt(e.target.value) || 0 }
                        }
                      })}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Mensile Privato
                    </label>
                    <input
                      type="number"
                      value={formData.pricing.monthly.privato}
                      onChange={(e) => setFormData({
                        ...formData,
                        pricing: {
                          ...formData.pricing,
                          monthly: { ...formData.pricing.monthly, privato: parseInt(e.target.value) || 0 }
                        }
                      })}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Annuale ONLUS
                    </label>
                    <input
                      type="number"
                      value={formData.pricing.yearly.onlus}
                      onChange={(e) => setFormData({
                        ...formData,
                        pricing: {
                          ...formData.pricing,
                          yearly: { ...formData.pricing.yearly, onlus: parseInt(e.target.value) || 0 }
                        }
                      })}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Annuale Privato
                    </label>
                    <input
                      type="number"
                      value={formData.pricing.yearly.privato}
                      onChange={(e) => setFormData({
                        ...formData,
                        pricing: {
                          ...formData.pricing,
                          yearly: { ...formData.pricing.yearly, privato: parseInt(e.target.value) || 0 }
                        }
                      })}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                </div>
              </div>

              {/* Limiti */}
              <div>
                <h3 className="font-semibold text-gray-900 mb-3">Limiti</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Max Minori
                    </label>
                    <input
                      type="number"
                      value={formData.limits.maxMinori}
                      onChange={(e) => setFormData({
                        ...formData,
                        limits: { ...formData.limits, maxMinori: parseInt(e.target.value) || 0 }
                      })}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                    <p className="text-xs text-gray-500 mt-1">999999 = illimitati</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Max Educatori
                    </label>
                    <input
                      type="number"
                      value={formData.limits.maxEducatori}
                      onChange={(e) => setFormData({
                        ...formData,
                        limits: { ...formData.limits, maxEducatori: parseInt(e.target.value) || 0 }
                      })}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Max Coordinatori
                    </label>
                    <input
                      type="number"
                      value={formData.limits.maxCoordinatori}
                      onChange={(e) => setFormData({
                        ...formData,
                        limits: { ...formData.limits, maxCoordinatori: parseInt(e.target.value) || 0 }
                      })}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Mesi Storico
                    </label>
                    <input
                      type="number"
                      value={formData.limits.storageMonths}
                      onChange={(e) => setFormData({
                        ...formData,
                        limits: { ...formData.limits, storageMonths: parseInt(e.target.value) || 0 }
                      })}
                      className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Colonna Preview */}
            <div>
              <h3 className="font-semibold text-gray-900 mb-3">Anteprima Card</h3>
              <PlanCardPreview plan={{ ...formData, planId: plan.planId }} isPreview betaMode={betaMode} />
            </div>
          </div>

          {/* Actions */}
          <div className="mt-6 pt-4 border-t flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="submit"
              disabled={saving}
              className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50"
            >
              {saving ? 'Salvataggio...' : 'Salva Modifiche'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

// Helper per estrarre array plans dalla risposta API
const extractPlans = (response) => {
  // Prova diverse strutture di risposta
  if (Array.isArray(response.data)) {
    return response.data
  }
  if (Array.isArray(response.data?.data)) {
    return response.data.data
  }
  if (Array.isArray(response.data?.data?.plans)) {
    return response.data.data.plans
  }
  if (Array.isArray(response.data?.plans)) {
    return response.data.plans
  }
  
  console.warn('Struttura risposta API non riconosciuta:', response.data)
  return []
}

// Pagina principale
export default function PlansPage() {
  const [plans, setPlans] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [editingPlan, setEditingPlan] = useState(null)
  const [successMessage, setSuccessMessage] = useState('')
  // FIX: Stato per betaMode da SystemSettings
  const [betaMode, setBetaMode] = useState(true)
  const [settingsLoading, setSettingsLoading] = useState(true)

  useEffect(() => {
    fetchPlans()
    fetchSettings()
  }, [])

  const fetchPlans = async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await adminApi.getPlans()
      console.log('API Response:', response.data) // Debug
      const plansData = extractPlans(response)
      setPlans(plansData)
    } catch (err) {
      setError('Errore caricamento piani: ' + (err.message || 'Errore sconosciuto'))
      console.error('Errore fetchPlans:', err)
    } finally {
      setLoading(false)
    }
  }

  // FIX: Recupera betaMode da SystemSettings
  const fetchSettings = async () => {
    try {
      setSettingsLoading(true)
      const response = await adminApi.getSettings()
      const settings = response.data?.data?.settings || response.data?.settings
      setBetaMode(settings?.features?.betaMode ?? true)
    } catch (err) {
      console.error('Errore caricamento settings:', err)
      // Default a true se errore
      setBetaMode(true)
    } finally {
      setSettingsLoading(false)
    }
  }

  // FIX: Toggle betaMode
  const handleToggleBetaMode = async () => {
    try {
      const newValue = !betaMode
      await adminApi.updateFeatures({ betaMode: newValue })
      setBetaMode(newValue)
      setSuccessMessage(newValue 
        ? 'Beta Mode attivato - prezzi nascosti' 
        : 'Beta Mode disattivato - prezzi visibili'
      )
      setTimeout(() => setSuccessMessage(''), 3000)
    } catch (err) {
      console.error('Errore toggle betaMode:', err)
      setError('Errore nell\'aggiornamento del beta mode')
    }
  }

  const handleSavePlan = async (planId, data) => {
    try {
      await adminApi.updatePlan(planId, data)
      setSuccessMessage('Piano aggiornato con successo!')
      setTimeout(() => setSuccessMessage(''), 3000)
      fetchPlans()
    } catch (err) {
      throw err
    }
  }

  const handleTogglePlan = async (planId) => {
    try {
      await adminApi.togglePlan(planId)
      fetchPlans()
    } catch (err) {
      console.error('Errore toggle piano:', err)
    }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Gestione Piani</h1>
          <p className="text-gray-500 mt-1">Configura prezzi, limiti e funzionalità dei piani</p>
        </div>
        
        {/* FIX: Toggle Beta Mode */}
        <div className="flex items-center gap-3">
          <span className="text-sm text-gray-600">Beta Mode:</span>
          <button
            onClick={handleToggleBetaMode}
            disabled={settingsLoading}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              betaMode ? 'bg-green-500' : 'bg-gray-300'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                betaMode ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
          <span className={`text-xs font-medium ${betaMode ? 'text-green-600' : 'text-gray-500'}`}>
            {betaMode ? 'Attivo' : 'Disattivo'}
          </span>
        </div>
      </div>

      {/* Beta Mode Info */}
      <div className={`p-4 rounded-lg border ${betaMode ? 'bg-green-50 border-green-200' : 'bg-gray-50 border-gray-200'}`}>
        <div className="flex items-start gap-3">
          <Info className={`h-5 w-5 mt-0.5 ${betaMode ? 'text-green-600' : 'text-gray-500'}`} />
          <div>
            <p className={`text-sm font-medium ${betaMode ? 'text-green-800' : 'text-gray-700'}`}>
              {betaMode 
                ? '🎉 Beta Mode Attivo - I prezzi sono nascosti (blur) per tutti gli utenti'
                : 'Beta Mode Disattivo - I prezzi sono visibili a tutti gli utenti'
              }
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Questa impostazione controlla la visualizzazione dei prezzi su: 
              Frontend Coordinatori, Pannello Organization, e questo Admin Panel.
            </p>
          </div>
        </div>
      </div>

      {/* Success Message */}
      {successMessage && (
        <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg flex items-center gap-2">
          <Check className="w-5 h-5" />
          {successMessage}
        </div>
      )}

      {/* Error */}
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg flex items-center gap-2">
          <AlertCircle className="w-5 h-5" />
          {error}
          <button onClick={fetchPlans} className="ml-auto">
            <RefreshCw className="w-4 h-4" />
          </button>
        </div>
      )}

      {/* Empty State */}
      {!error && plans.length === 0 && (
        <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded-lg">
          Nessun piano trovato. Verifica che i piani siano stati inizializzati nel database.
        </div>
      )}

      {/* Plans Grid */}
      {plans.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {plans.map((plan) => (
            <div key={plan.planId || plan._id} className="relative">
              {/* Status Badge */}
              {!plan.isActive && (
                <div className="absolute -top-2 -right-2 z-10">
                  <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                    Disattivato
                  </span>
                </div>
              )}
              
              {/* FIX: Passa betaMode al componente */}
              <PlanCardPreview plan={plan} betaMode={betaMode} />
              
              {/* Actions */}
              <div className="mt-4 flex gap-2">
                <button
                  onClick={() => setEditingPlan(plan)}
                  className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
                >
                  <Pencil className="w-4 h-4" />
                  Modifica
                </button>
                <button
                  onClick={() => handleTogglePlan(plan.planId || plan._id)}
                  className={`px-3 py-2 rounded-lg transition-colors ${
                    plan.isActive
                      ? 'bg-red-100 text-red-700 hover:bg-red-200'
                      : 'bg-green-100 text-green-700 hover:bg-green-200'
                  }`}
                >
                  {plan.isActive ? 'Disattiva' : 'Attiva'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Tabella Dettaglio */}
      {plans.length > 0 && (
        <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
          <div className="px-6 py-4 border-b bg-gray-50">
            <h2 className="font-semibold text-gray-900">Confronto Dettagliato</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Piano</th>
                  <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Mensile ONLUS</th>
                  <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Mensile Privato</th>
                  <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Max Minori</th>
                  <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Max Educatori</th>
                  <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Storico</th>
                  <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Stato</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {plans.map((plan) => (
                  <tr key={plan.planId || plan._id} className="hover:bg-gray-50">
                    <td className="px-4 py-3">
                      <div className="font-medium text-gray-900">{plan.displayName}</div>
                      <div className="text-xs text-gray-500">{plan.planId}</div>
                    </td>
                    <td className="px-4 py-3 text-center">
                      {/* FIX: Prezzi sempre visibili in tabella admin */}
                      €{((plan.pricing?.monthly?.onlus || 0) / 100).toFixed(2)}
                    </td>
                    <td className="px-4 py-3 text-center">
                      €{((plan.pricing?.monthly?.privato || 0) / 100).toFixed(2)}
                    </td>
                    <td className="px-4 py-3 text-center">
                      {plan.limits?.maxMinori === 999999 ? '∞' : plan.limits?.maxMinori}
                    </td>
                    <td className="px-4 py-3 text-center">
                      {plan.limits?.maxEducatori === 999999 ? '∞' : plan.limits?.maxEducatori}
                    </td>
                    <td className="px-4 py-3 text-center">
                      {plan.limits?.storageMonths === 999999 ? '∞' : `${plan.limits?.storageMonths} mesi`}
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className={`inline-flex px-2 py-1 text-xs rounded-full ${
                        plan.isActive 
                          ? 'bg-green-100 text-green-700' 
                          : 'bg-red-100 text-red-700'
                      }`}>
                        {plan.isActive ? 'Attivo' : 'Inattivo'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Edit Modal - FIX: Passa betaMode */}
      {editingPlan && (
        <EditPlanModal
          plan={editingPlan}
          onClose={() => setEditingPlan(null)}
          onSave={handleSavePlan}
          betaMode={betaMode}
        />
      )}
    </div>
  )
}
